import React, { useRef } from "react";
import QRCode from "react-qr-code";
import { X } from "lucide-react";

export default function SedeQRModal({ sede, onClose }) {
  const qrRef = useRef(null);

  if (!sede) return null;

  const API_URL = process.env.REACT_APP_URL;
 // ✅ Después
const sedeUrl = `${API_URL}sede/${sede.id ?? sede._id}`;

  const downloadQR = () => {
    const svg = qrRef.current.querySelector("svg");
    const serializer = new XMLSerializer();
    const svgStr = serializer.serializeToString(svg);

    const canvas = document.createElement("canvas");
    const size = 500;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext("2d");

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, size, size);

    const img = new Image();
    img.src = "data:image/svg+xml;base64," + window.btoa(svgStr);

    img.onload = () => {
      ctx.drawImage(img, 50, 50, 400, 400);

      const logo = new Image();
      logo.src = "/favicon.png";

      logo.onload = () => {
        const logoSize = 90;
        const x = size / 2 - logoSize / 2;
        const y = size / 2 - logoSize / 2;

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(x - 12, y - 12, logoSize + 24, logoSize + 24);

        ctx.drawImage(logo, x, y, logoSize, logoSize);

        const link = document.createElement("a");
        link.download = `qr-sede-${sede.name}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      };
    };
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-2xl p-6 w-80 text-center shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition"
        >
          <X size={22} />
        </button>

        <h3 className="text-xl font-bold mb-4">{sede.name}</h3>

        <div
          ref={qrRef}
          className="relative bg-white p-6 rounded-2xl shadow border mx-auto"
          style={{ width: 220, height: 220 }}
        >
          <QRCode
            value={sedeUrl}
            size={180}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
          />

          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="bg-white p-2 rounded-xl shadow">
              <img
                src="/favicon.png"
                alt="Qkiere"
                className="w-12 h-12 object-contain"
              />
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 break-all mt-4">{sedeUrl}</p>

        <button
          onClick={downloadQR}
          className="mt-4 w-full py-2 bg-supernova-500 hover:bg-supernova-600 
                     text-white rounded-xl font-semibold transition"
        >
          Descargar QR
        </button>

        <button
          onClick={onClose}
          className="mt-3 w-full py-2 bg-gray-200 hover:bg-gray-300 
                     text-gray-800 rounded-xl font-semibold transition"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}
